import React from 'react';
import { Box, Chip } from '@mui/material';
import { RECORD_PERMISSION_COPY } from '../../utils/recordPermissionCopy';

const PRESET_OPTIONS = [
  { id: 'readOnly', label: RECORD_PERMISSION_COPY.presets.readOnly },
  { id: 'agent', label: RECORD_PERMISSION_COPY.presets.agent },
  { id: 'manager', label: RECORD_PERMISSION_COPY.presets.manager },
];

export default function RecordPermissionPresets({ disabled, onSelect }) {
  return (
    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.75 }}>
      {PRESET_OPTIONS.map((preset) => (
        <Chip
          key={preset.id}
          label={preset.label}
          size="small"
          variant="outlined"
          disabled={disabled}
          onClick={() => onSelect?.(preset.id)}
          aria-describedby={`preset-${preset.id}-desc`}
        />
      ))}
    </Box>
  );
}
